// Polyfill: ES2023 Array 메서드 for Samsung Internet 17 등 구형 브라우저 (Fixes QUIZ-APP-31D)
import { isServer } from '@toss/utils';

import 'core-js/actual/array/find-last';
import 'core-js/actual/array/find-last-index';
import './shared/logger';

import { logVersion } from './utils/version';

if (!isServer()) {
  logVersion();
}
